import React, { ReactNode } from "react";

interface PageContainerProps {
  children: ReactNode;
}

/**
 * Vertical rhythm for a page's sections. Page padding, background and max
 * width now live in the app shell (Sidebar.tsx), so this no longer sets them.
 */
export const PageContainer: React.FC<PageContainerProps> = ({ children }) => {
  return <div className="space-y-6">{children}</div>;
};

export default PageContainer;
